import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ConfigProvider, App as AntApp } from 'antd';
import { BrowserRouter } from 'react-router-dom';
import { store } from './app/store';
import { theme } from './styles/theme';
import Router from './app/router';
import AuthBootstrap from './components/AuthBootstrap';
import './styles/global.css';

function Root() {
  return (
    <Provider store={store}>
      <ConfigProvider theme={theme}>
        <AntApp>
          <BrowserRouter>
            <AuthBootstrap>
              <Router />
            </AuthBootstrap>
          </BrowserRouter>
        </AntApp>
      </ConfigProvider>
    </Provider>
  );
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Root />);
